import React from 'react';
import { Header } from '../../row/header';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AheadPreview from '../../ahead/ahead-preview';
import { setPageType } from '../../actions/builder-action';

const Author = () => {
  const { publisherId = '' } = useParams();
  const dispatch = useDispatch();
  dispatch(setPageType('author'));
  return (
    <>
      <Header publisherId={publisherId} />
      <AheadPreview />
    </>
  );
};

export default Author;
